import { reactive, ref, computed } from "vue";
import { setConfig } from '@blade-sxp/monitoring-center/api/index';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store/index';
import { deepClone, vm } from '@blade-sxp/monitoring-center/utils';
const store = useMonitoringStore();
const getRule = () => {
    const r = /^([1-9]\d*|[0]{1,1})$/;
    const rules = {
        currentDeviceAlertDuration: [
            { required: true, message: `${vm?.$t('pleaseEnterCurrentDeviceAlertDuration')}`, trigger: 'blur' },
            {
                validator: (_, value, callback) => {
                    if (r.test(value)) {
                        callback();
                    }
                    else {
                        callback(new Error(vm?.$t('pleaseEnterPositiveInteger').toString()));
                    }
                },
                trigger: 'blur',
            },
            {
                validator: (_, value, callback) => {
                    if (Number(value) >= 5 && Number(value) <= 60) {
                        callback();
                    }
                    else {
                        callback(new Error(vm?.$t('pleaseEnterPositiveIntegerOf').toString()));
                    }
                },
                trigger: 'blur',
            },
        ],
        linkageDeviceAlertDelayTime: [
            { required: true, message: `${vm?.$t('pleaseEnterLinkageDeviceAlertDelayTime')}`, trigger: 'blur' },
            {
                validator: (_, value, callback) => {
                    if (r.test(value)) {
                        callback();
                    }
                    else {
                        callback(new Error(vm?.$t('pleaseEnterPositiveInteger').toString()));
                    }
                },
                trigger: 'blur',
            },
            {
                validator: (_, value, callback) => {
                    if (Number(value) >= 0 && Number(value) <= 60) {
                        callback();
                    }
                    else {
                        callback(new Error(vm?.$t('pleaseEnterPositiveIntegerOfOne').toString()));
                    }
                },
                trigger: 'blur',
            },
        ],
        linkageDeviceAlertDuration: [
            { required: true, message: `${vm?.$t('pleaseEnterLinkageDeviceAlertDuration')}`, trigger: 'blur' },
            {
                validator: (_, value, callback) => {
                    if (r.test(value)) {
                        callback();
                    }
                    else {
                        callback(new Error(vm?.$t('pleaseEnterPositiveInteger').toString()));
                    }
                },
                trigger: 'blur',
            },
            {
                validator: (_, value, callback) => {
                    if (Number(value) >= 5 && Number(value) <= 60) {
                        callback();
                    }
                    else {
                        callback(new Error(vm?.$t('pleaseEnterPositiveIntegerOf').toString()));
                    }
                },
                trigger: 'blur',
            },
        ],
    };
    return rules;
};
export const useAlarmSetting = (msg, dialogVisible, ruleForm, emit) => {
    // const emit = defineEmits(['update:dialogVisible']);
    const visible = computed({
        get: () => dialogVisible,
        set: (val) => emit('update:dialogVisible', val),
    });
    const rules = getRule();
    const form = reactive(msg.value.setting && JSON.stringify(msg.value.setting) !== '{}' ? {
        ...msg.value.setting,
        selectDeviceId: msg.value.setting && msg.value.setting?.linkageDevices && msg.value.setting?.linkageDevices[0]?.id || '',
    } : {
        linkageDevices: [''],
        currentDeviceAlertDuration: 10,
        linkageDeviceAlertDelayTime: 3,
        linkageDeviceAlertDuration: 8,
        status: 'ENABLE',
        propertyDisplay: 'ENABLE',
        configId: 0,
        selectDeviceId: msg.value?.deviceId ?? '',
    });
    const loading = ref(true);
    const changeCascader = (deviceId) => {
        form.selectDeviceId = deviceId;
    };
    const getBaseConfig = () => {
        // getConfig({ operateIds: [msg.value.id] }).then((res: any) => {
        //   if (res.length) {
        //     form = res[0];
        //     res[0]?.linkageDevices && (form.selectDeviceId = res[0]?.linkageDevices[0]?.id);
        //   }
        // }).finally(() => {
        loading.value = false;
        // });
    };
    const cancelDialog = () => {
        emit('update:dialogVisible', false);
    };
    const onSubmit = () => {
        if (!ruleForm.value)
            return;
        ruleForm.value.validate((valid) => {
            if (valid) {
                const { currentDeviceAlertDuration, selectDeviceId, linkageDeviceAlertDelayTime, linkageDeviceAlertDuration, propertyDisplay, status, configId } = form;
                const param = {
                    currentDeviceAlertDuration: Number(currentDeviceAlertDuration),
                    deviceId: String(msg.value.id),
                    linkageDevice: [selectDeviceId],
                    linkageDeviceAlertDelayTime: Number(linkageDeviceAlertDelayTime),
                    linkageDeviceAlertDuration: Number(linkageDeviceAlertDuration),
                    propertyDisplay,
                    resultType: 'ALERT',
                    status,
                    configId,
                };
                setConfig(param).then((res) => {
                    updateVideoData(param); // 更新视频框数据
                    cancelDialog();
                });
            }
            else {
                return false;
            }
        });
    };
    const updateVideoData = (param) => {
        const setting = {
            ...param,
            linkageDevices: [
                {
                    id: param.linkageDevice[0],
                },
            ],
        };
        updateVideoDetailData(param, setting);
        updateVideoSettingData(setting);
    };
    const updateVideoDetailData = (param, setting) => {
        const videoDetailArr = store.videoDetailArr;
        const deepVideoDetailData = deepClone(videoDetailArr);
        const selectVideoItem = deepVideoDetailData?.find(({ deviceId }) => deviceId === param.deviceId);
        if (!selectVideoItem)
            return;
        const rtsp = selectVideoItem.rtsp;
        selectVideoItem.rtsp = 'rtsp://';
        selectVideoItem.setting = setting;
        store.updateVideoDatailData(deepVideoDetailData);
        if (selectVideoItem?.extendData?.incidentType === 'FACE_ALERT') {
            selectVideoItem.extendData = {
                ...selectVideoItem.extendData,
                drawAttributes: param.propertyDisplay === 'ENABLE',
                drawRect: param.status === 'ENABLE',
                showRect: param.status === 'ENABLE',
            };
        }
        setTimeout(() => {
            selectVideoItem.rtsp = rtsp;
            store.updateVideoDatailData(deepVideoDetailData);
        }, 50);
    };
    const updateVideoSettingData = (setting) => {
        const videoSettingArr = store.videoSettingArr;
        const deepVideoSettingArr = deepClone(videoSettingArr);
        const settingItem = deepVideoSettingArr?.find(({ deviceId }) => deviceId === msg.value.deviceId);
        if (!settingItem)
            return;
        settingItem.currentDeviceAlertDuration = setting.currentDeviceAlertDuration;
        settingItem.linkageDevice = setting.linkageDevice[0];
        settingItem.status = setting.status;
        settingItem.propertyDisplay = setting.propertyDisplay;
        settingItem.linkageDeviceAlertDelayTime = setting.linkageDeviceAlertDelayTime;
        settingItem.linkageDeviceAlertDuration = setting.linkageDeviceAlertDuration;
        store.updateVideoSettingData(settingItem);
    };
    return {
        getBaseConfig,
        changeCascader,
        onSubmit,
        cancelDialog,
        form,
        loading,
        visible,
        rules
    };
};
